import { render, staticRenderFns } from "./EditManager.component.vue?vue&type=template&id=64d32848"
import script from "./EditManager.component.vue?vue&type=script&lang=ts"
export * from "./EditManager.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports